/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import {useIntl} from 'react-intl'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import {login} from '../redux/AuthCRUD'

const API_URL = process.env.REACT_APP_API_URL

const loginSchema = Yup.object().shape({
  email: Yup.string()
      //.email('Wrong email format')
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Email is required'),
  password: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Password is required'),
})

const initialValues = {
  email: 'Researcher',
  password: 'Akabia2021!',
}


//const DRUPAL_URL_LOGIN = process.env.DRUPAL_URL_LOGIN
export const DRUPAL_URL_LOGIN = `${API_URL}/login/openid` 

const loginRedirect = () => {
	  
	  //REDIRECT DRUPAL CONNEXION
	  window.location.href = DRUPAL_URL_LOGIN + "?redirect=" + window.location.href
  
    //dispatch(auth.actions.logout())
  }
  

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
    const intl = useIntl()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        login(values.email, values.password)
            .then((response) => {
              setLoading(false)
              
              
             // dispatch(auth.actions.login('', '', response.data))
              
              
              if(response.data.access_token){
              	dispatch(auth.actions.login(response.data.access_token, '', ''))
              }else{
	            dispatch(auth.actions.login('', response.data, ''))
              }
              
              
              
              //dispatch(auth.actions.session_token(response.data))
              // console.log("login", response.data)
                
                
                
             /* dispatch({
                type: '[Login] Action',
                payload: {
                  accessToken : response.data.access_token,
                  refreshToken : response.data.refresh_token,
                  expiresIn : response.data.expires_in,
                  user: data.username
                }
              })*/
            })
            .catch((error) => {
              setLoading(false)
              setSubmitting(false)
              setStatus('The login detail is incorrect')
            })
      }, 1000)
    },
  })
  
  useEffect(() => {
    //setLoading(true)
      setTimeout(() => {
	    /*** CHECK COOKIE CONNEXION DRUPAL ***/
	    /*
        login("", "")
            .then((response) => {
              setLoading(false)
              console.log(response.data)
              if(response.data.access_token){
              	dispatch(auth.actions.login(response.data.access_token, '', ''))
              }else{
	            dispatch(auth.actions.login('', response.data, ''))
              }
              
            })
            .catch((error) => {
              setLoading(false)
            })
            */
      }, 1000)
  }, [])


return (
      <form
          className='form w-100'
          onSubmit={formik.handleSubmit}
          noValidate
          id='kt_login_signin_form'
      >

        <div className='text-left mb-10'>
        </div>

        {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
        )}
        
        <div className='text-center'>

            {!loading && 
	            <a
		            target='_blank'
		            className='btn btn-custom btn-sm btn-primary w-100'
		            onClick={loginRedirect}
		        >
		          <span className='btn-label indicator-label'>SE CONNECTER</span>
		        </a>
		    }
            {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
            )}
        </div>
      </form>
  )



/*
  return (
      <form
          className='form w-100'
          onSubmit={formik.handleSubmit}
          noValidate
          id='kt_login_signin_form'
      >
      
        <div className='text-left mb-10'>
          <h2 className='text-dark mt-5'>{intl.formatMessage({id: 'AUTH.GENERAL.CONNEXION'})}</h2>
        </div>

        {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
        )}

        <div className='fv-row mb-10'>
          <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
          <input
              placeholder='Email'
              {...formik.getFieldProps('email')}
              className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
              )}
              type='email'
              name='email'
              autoComplete='off'
          />
          {formik.touched.email && formik.errors.email && (
              <div className='fv-plugins-message-container'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
          )}
        </div>
       
        <div className='fv-row mb-10'>
          <div className='d-flex justify-content-between mt-n5'>
            <div className='d-flex flex-column mb-2'>
              <label className='form-label fw-bolder text-dark fs-6 mb-0'>{intl.formatMessage({id: 'AUTH.INPUT.PASSWORD'})}</label>
            </div>
          </div>
          <input
              type='password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
              )}
          />
          {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
          )}
            <Link
                to='/auth/forgot-password'
                className='link-primary fs-7 fw-bolder'
            >
                Forgot Password ?
            </Link>
        </div>
        
        <div className='text-center'>
          <button
              type='submit'
              id='kt_sign_in_submit'
              className='btn btn-lg btn-primary w-100 mb-5'
              disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>Continue</span>}
            {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
            )}
          </button>
        </div>
      </form>
  )
  
  */
}
